import 'scripts/react-components/utils/algolia/data-layer'
import reactComponentLoader from 'scripts/react-component-loader'

import WishlistProviderMethods from 'site/Wishlist/provider'

import {
  ServiceLabel,
  Variants,
  PaymentMethodsModal,
  PurchaseButtonsSection
} from './components'
import { CarouselContainer } from './containers'
import { Product } from '.'

const ProductEntry = ({
  isAssistedSale,
  isWhatsappEnabled,
  isOnDemand,
  isOfferSchemaEnabled,
  shouldRenderFreeShippingBadge,
  shopName = 'Leroy Merlin',
  brandedInstallments,
  installments,
  discountPercentage: discount,
  discountType,
  paymentMethodsDiscount,
  price,
  product,
  packaging,
  purchaseButtons,
  regionId,
  description,
  disclaimer,
  title,
  url,
  badges
}) => {
  try {
    const parsedBrandedInstallments =
      brandedInstallments && JSON.parse(brandedInstallments)
    const parsedInstallments = installments && JSON.parse(installments)
    const parsedDiscount = discount ? parseFloat(discount) : 0
    const parsedPrice = price && JSON.parse(price)
    const parsedProduct = product && JSON.parse(product)
    const parsedPackaging = packaging && JSON.parse(packaging)
    const parsedPurchaseButtons = JSON.parse(purchaseButtons)
    const parsedDisclaimer = JSON.parse(disclaimer)
    const formattedPurchaseButtons = {
      ecommerce: parsedPurchaseButtons.ecommerce.enabled,
      pickupInStore: parsedPurchaseButtons.pickupInStore.enabled,
      assistedSale: parsedPurchaseButtons.assistedSale.visible
    }
    const parsedBadges = JSON.parse(badges)

    return (
      <WishlistProviderMethods>
        <Product
          isAssistedSale={isAssistedSale}
          isWhatsappEnabled={isWhatsappEnabled}
          shouldRenderFreeShippingBadge={shouldRenderFreeShippingBadge}
          shopName={shopName}
          brandedInstallments={parsedBrandedInstallments}
          installments={parsedInstallments}
          discountPercentage={parsedDiscount}
          discountType={discountType}
          paymentMethodsDiscount={paymentMethodsDiscount}
          price={parsedPrice}
          product={parsedProduct}
          packaging={parsedPackaging}
          regionId={regionId}
          purchaseButtons={formattedPurchaseButtons}
          description={description}
          disclaimer={parsedDisclaimer}
          title={title}
          url={url}
          badges={parsedBadges}
        />
      </WishlistProviderMethods>
    )
  } catch {}
}

const CarouselContainerEntry = ({ productId, productName, productPrice }) => {
  try {
    const parsedPrice = JSON.parse(productPrice)

    return (
      <WishlistProviderMethods>
        <CarouselContainer
          productId={productId}
          productName={productName}
          productPrice={parsedPrice}
        />
      </WishlistProviderMethods>
    )
  } catch {}
}

reactComponentLoader(ProductEntry, '[data-new-product-page]')
reactComponentLoader(CarouselContainerEntry, '[data-featured-carousel]')
reactComponentLoader(ServiceLabel, '[data-service-label]')
reactComponentLoader(Variants, '[data-variants]')
reactComponentLoader(PaymentMethodsModal, '[data-payment-methods-modal]')
reactComponentLoader(PurchaseButtonsSection, '[data-purchase-buttons-section]')
